import React from 'react';
import Spinner from './Spinner';

/** Min height so the loader occupies the same region as tab content (below header / above nav). */
export const MAIN_LOADER_MIN_HEIGHT = 'min-h-[calc(100dvh-10.5rem)]';
export const MAIN_SPINNER_SIZE = 120;

type MainContentLoaderProps = {
  /** When true, absolutely covers a `relative` parent (in-page overlay, not full viewport white). */
  overlay?: boolean;
};

const MainContentLoader: React.FC<MainContentLoaderProps> = ({ overlay }) => {
  if (overlay) {
    return (
      <div
        className={`absolute inset-0 z-30 flex items-center justify-center bg-amber-50/30 pointer-events-auto ${MAIN_LOADER_MIN_HEIGHT}`}
        aria-busy="true"
        aria-live="polite"
      >
        <Spinner size={MAIN_SPINNER_SIZE} />
      </div>
    );
  }

  return (
    <div
      className={`${MAIN_LOADER_MIN_HEIGHT} flex items-center justify-center bg-transparent`}
      aria-busy="true"
    >
      <Spinner size={MAIN_SPINNER_SIZE} />
    </div>
  );
};

export default MainContentLoader;
